import type { RadarValues } from '../queries/useTeamRadar';

export interface PlayerAnalysisPromptData {
  today: string;
  playerName: string;
  position: string | null;
  ratings: RadarValues;
  velocity: RadarValues;
  ratingsCount: number;
  activeGoals: string[];
  planMilestones: string[];
  clipNotes: string[];
}

export const PLAYER_DEVELOPMENT_ANALYSIS_PROMPT = `You are a youth football player development analyst.

Return ONLY valid JSON. No prose, no markdown fences. Schema:
{
  "summary": string,
  "actions": [
    { "corner": "tech" | "phys" | "psych" | "social" | "general", "action": string, "rationale": string },
    { "corner": "tech" | "phys" | "psych" | "social" | "general", "action": string, "rationale": string },
    { "corner": "tech" | "phys" | "psych" | "social" | "general", "action": string, "rationale": string }
  ],
  "parent_highlight": string
}

Rules:
- summary is 2 to 3 sentences about the player's current development trajectory.
- actions has exactly 3 items, most impactful first.
- Each action is observable in a training session or match.
- parent_highlight is one warm, parent-safe sentence. No scores, rankings, private coach notes, or comparison to teammates.
- Use growth-mindset language: effort, choices, cues, and evidence, not innate ability.
- Do not invent a specific recent moment unless it is present in activeGoals, planMilestones, or clipNotes.`;

export function buildPlayerAnalysisUserContent(data: PlayerAnalysisPromptData): string {
  return JSON.stringify({
    today: data.today,
    player_name: data.playerName,
    position: data.position,
    ratings_28d: data.ratings,
    velocity_28d: data.velocity,
    ratings_count: data.ratingsCount,
    active_goals: data.activeGoals,
    plan_milestones: data.planMilestones,
    clip_notes: data.clipNotes,
  });
}
